import React, { useMemo, useState } from "react";
import classes from "./UnwrapAsStx20Form.module.scss";
import { BigPurpuleButton } from "../../Buttons/BigPurpuleButton/BigPurpuleButton.tsx";
import useData from "../../../hooks/useData.ts";
import { Status } from "../../../constants.ts";
import { SuccessModal } from "../../Modals/SuccessModal/SuccessModal.tsx";
import { validateIntegerValue } from "../../../helpers.ts";
import { Input } from "../../InscribeForm/InscribeInput/Input.tsx";
import { TickerInputWithBalance } from "../../TickerInput/TickerInputWithBalance.tsx";

type Props = {};
export const UnwrapAsStx20Form = ({}: Props) => {
  const { unWrap } = useData();
  const [ticker, setTicker] = useState(
    "SP3K8BC0PPEVCV7NZ6QSRWPQ2JE9E5B6N3PA0KBR9.stx20-stxs"
  );
  const [tickerError, setTickerError] = useState("");
  const [total, setTotal] = useState("");
  const [totalError, setTotalError] = useState("");
  const [isLoading, setLoading] = useState(false);
  const [balance, setBalance] = useState("");
  const [status, setStatus] = useState<Status | null>();

  const handleTransfer = async () => {
    setLoading(true);

    const onSuccess = () => {
      setStatus(Status.SUCCESS);
      setTicker("");
      setTotal("");
      setLoading(false);
    };
    const onCancel = () => {
      setStatus(Status.FAIL);
      setLoading(false);
    };

    try {
      await unWrap(Number(total) * Math.pow(10, 8), onSuccess, onCancel);
    } catch (error) {
      setStatus(Status.FAIL);
      setLoading(false);
      console.error(error);
    }
  };

  const handleTotalChange = (val) => {
    setTotal(val);
    validateIntegerValue(val, setTotalError, "", "Invalid total");
    if (Number(val) > Number(balance)) {
      setTotalError("Insufficient funds");
    }
  };

  const isDisabled = useMemo(() => {
    return total === "" || totalError !== "";
  }, [total, totalError]);

  return (
    <div className={classes.wrapper}>
      {!!status && (
        <SuccessModal status={status} onClose={() => setStatus(null)} />
      )}
      <div className={classes.inputWrapper}>
        <div className={classes.item}>
          <TickerInputWithBalance
            setBalance={setBalance}
            onTickerErrorHandler={setTickerError}
            ticker={ticker}
            onChangeTicker={setTicker}
            placeholder="STXS"
            tickerError={tickerError}
            editable={false}
            contractTicker
          />
        </div>
        <div className={classes.item}>
          <Input
            name="total"
            placeholder="Amount"
            value={total}
            onChange={handleTotalChange}
            error={totalError}
            max={Number(balance)}
          />
        </div>
      </div>
      <div className={classes.feeAlert}>Unwrap fee: 1 STX</div>
      <div className={classes.buttonWrapper}>
        <BigPurpuleButton
          onClick={handleTransfer}
          text={"Unwrap"}
          disabled={isDisabled}
          className={classes.button}
        />
      </div>
    </div>
  );
};
